import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import getClients from "../../services/getClients";
import ImageInput from "../../widgets/ImageInput";
import updateClient from "../../services/updateClient";
import { NineCellLoading } from 'react-loadingg';
import Switch from "react-switch";
import '../../widgets/css/style.css';
import Utils from "../../utils/utils";
import { TbCalendarTime } from "react-icons/tb";

export default class EditClient extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.selectRef = React.createRef();
    this.selectCoursesRitiratiRef = React.createRef();
    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      cliente: null,
      nome: '',
      cognome: '',
      mail: '',
      mail2Tipo: '',
      mail2: '',
      indirizzo: '',
      citta: '',
      codiceFiscale: '',
      telefono: '',
      telefono2Tipo: '',
      telefono2: '',
      corsi: [], 
      corsiRitirati: [], 
      ads: true,
    }

    this.grid = 2;

    this.pageTitle = "Modifica cliente";
  }


  async componentDidMount(){

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentCliente = cookies.get('currentClient', { path: '/' });

    var cliente = undefined;
    this.clienti = await getClients(username, token);
    this.clienti.forEach((cl) => {
      if (cl.id == currentCliente)
      cliente = cl;
    });
    console.log(cliente);
    this.setState({ isLoading: false, cliente: cliente, ads: cliente.ads_active === "0" ? true : false, exp: cliente.is_expirable === "0" ? false : true });
    console.log(this.state.exp);
  }

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.state.cliente == undefined) return <div />;

    return (
      <div >
        { !this.state.isLoading && (
          <div>
        <PageTitle title={this.pageTitle} />

        <div style={{ display: 'flex' }}>

          <div style={{ marginTop: 35 }}>
          <TextInput name={'Ragione Sociale'} value={this.state.cliente.ragioneSociale} 
            onChange={(text) => { this.setState(prevState => ({
              cliente: {
                ...prevState.cliente,           
                ragioneSociale: text
              }
            }))}
          } />

          <TextInput name={'Indirizzo'} value={this.state.cliente.indirizzo} 
            onChange={(text) => { this.setState(prevState => ({
              cliente: {
                ...prevState.cliente,           
                indirizzo: text
              }
            }))}
          } />

          <TextInput name={'Città'} value={this.state.cliente.citta} 
            onChange={(text) => { this.setState(prevState => ({
              cliente: {
                ...prevState.cliente,           
                citta: text
              }
            }))}
          } />

          <TextInput name={'Provincia'} value={this.state.cliente.provincia} 
            onChange={(text) => { this.setState(prevState => ({
              cliente: {
                ...prevState.cliente,           
                provincia: text
              }
            }))}
          } />

          <TextInput name={'CAP'} value={this.state.cliente.CAP} 
            onChange={(text) => { this.setState(prevState => ({
              cliente: {
                ...prevState.cliente,           
                CAP: text
              }
            }))}
          } />
          <br/>
            </div>
            <div style={{ marginLeft: 20 }}>
            <p>Contatti:</p>
          <TextInput name={'Email'} value={this.state.cliente.mail} 
            onChange={(text) => { this.setState(prevState => ({
              cliente: {
                ...prevState.cliente,           
                mail: text
              }
            }))}
          } />

          <TextInput name={'Telefono'} value={this.state.cliente.telefono} 
            onChange={(text) => { this.setState(prevState => ({
              cliente: {
                ...prevState.cliente,           
                telefono: text
              }
            }))}
          } />

          <ImageInput name={'Logo'} key={Math.random()} 
            value={this.state.cliente.logoImage}
            onChange={(val) => { this.setState(prevState => ({
              cliente: {
                ...prevState.cliente,           
                logoImage: val
              }
            }))}
          }
          />

          <br/>
            </div>
          </div>
          <br/>
            <div style={{ display: 'flex', marginTop: 0, marginLeft: 155, backgroundColor: 'lightblue', borderRadius: '10px', width: 365, padding: 10, boxShadow: '0px 2px 10px lightgrey' }}>
              <img src={ require('../../images/logotype.png') } style={{ height: 30, width: 30, marginRight: 10, marginTop: 3, marginLeft: 20 }} />
              <span className="settingSpan" style={{ marginTop: 8, textAlign: 'center' }}>Annunci pubblicitari</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={45} height={20} onChange={(checked) => { this.setState({ ads: checked }); }} checked={this.state.ads} />
          </div>
          <div style={{ display: 'flex', marginTop: 10, marginLeft: 155, backgroundColor: 'lightblue', borderRadius: '10px', width: 365, padding: 10, boxShadow: '0px 2px 10px lightgrey' }}>
              <TbCalendarTime style={{ height: 30, width: 30, marginRight: 10, marginTop: 3, marginLeft: 20, color:'black' }} />
              <span className="settingSpan" style={{ marginTop: 8, textAlign:'center' }}>Scadenza 30 giorni</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={45} height={20} onChange={(checked) => { this.setState({ exp: checked }); }} checked={this.state.exp} />
          </div><br/><br/>
          <p style={{ marginLeft: 10 }}>Nome del db: { this.state.cliente.db_name }</p>
          <br/>
          <FixButton title={'Salva'} callback={this.save.bind(this)} />
          </div>
          )}
      </div>
    );
  }

  async save () {
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });

      if (this.state.cliente.mail && !(/^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(this.state.cliente.mail))) {
        alert("Verifica la mail inserita.");
        return;
      }

      var strCorsiRitirati = "";
      this.state.corsiRitirati && this.state.corsiRitirati.forEach((corso) => {
        strCorsiRitirati += corso.value + ";";
      });

      var strCorsi = "";
      this.state.corsi && this.state.corsi.forEach(c => {
          strCorsi += c.value + ";";
      });

      let ret = await updateClient(username, token, this.state.cliente.id, this.state.cliente.ragioneSociale, this.state.cliente.indirizzo, this.state.cliente.citta, this.state.cliente.provincia, this.state.cliente.CAP, 
        this.state.cliente.mail, this.state.cliente.telefono, this.state.cliente.logoImage, this.state.cliente.db_name, this.state.ads, this.state.exp);
    
      if (ret.result == 'ok') {
        alert('Cliente ' + this.state.cliente.ragioneSociale + ' aggiornato con successo');
        window.location.href =  '/' + this.dbPath + '/#/admin/clients';
      } else {
        alert('Errore nell\'aggiornamento di: ' + this.state.cliente.ragioneSociale);
      }
    
  }

}

